import validator from 'validator';
import FormStore from '../stores/form_store';

/**
 * バリデーション
 */
const Validator = (name, value) => {
  let errs = []
    , inputValue
    , state = FormStore.getState().data;

  // 各年数入力の最大値、最小値
  const max_year = 2050;
  const min_year = 1900;

  switch (name) {
    case 'wnumber':
      /**
       * 妻診察券番号
       */
      if (validator.isEmpty(value)) {
        errs.push('診察券番号は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('数字以外が入力されています');
      }
      if (value.length !== 7) {
        errs.push('診察券番号は7桁で入力してください');
      }
      break;

    case 'wbirthday_year':
      /**
       * 妻生年月日（年）
       */
      if (validator.isEmpty(value)) {
        errs.push('生まれ年は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('数字以外が入力されています');
      }
      if (value.length !== 4) {
        errs.push('生まれ年は4桁で入力してください');
      }
      break;

    case 'wbirthday_month':
      /**
       * 妻生年月日（月）
       */
      if (validator.isEmpty(value)) {
        errs.push('出生月は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('数字以外が入力されています');
      }
      if (parseInt(value) <= 0 || parseInt(value) > 12 ) {
        errs.push('出生月は1〜12の数字で入力してください')
      }
      break;

    case 'wbirthday_date':
      /**
       * 妻生年月日（日）
       */
      if (validator.isEmpty(value)) {
        errs.push('出生日は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('数字以外が入力されています');
      }
      if (parseInt(value) <= 0 || parseInt(value) > 31 ) {
        errs.push('出生日は1〜31の数字で入力してください');
      }
      break;

    case 'is_address_change':
      /**
       * 住所変更について
       */
      inputValue = parseInt(value);
      if (validator.isEmpty(value)) {
        errs.push('住所変更については必須入力です');
      }
      if (!validator.isNumeric(value) || inputValue <= 0 || inputValue >= 3) {
        errs.push('入力内容が不正です');
      }
      break;

    case 'email':
      /**
       * メールアドレス
       */
      if (validator.isEmpty(value)) {
        errs.push('メールアドレスは必須入力です');
      }
      if (!validator.isEmail(value)) {
        errs.push('メールアドレスの形式が間違っています');
      }
      break;

    case 'treatments':
      /*
       * 妊娠に至った治療方法
       */
      if (validator.isEmpty(value)) {
        errs.push('治療方法は必須入力です');
      }
      break;

    case 'outcome':
      /**
       * 妊娠の転帰
       */
      if (value.length <= 0) {
        errs.push('妊娠の転帰は必須入力です');
      }
      for (let val of value) {
        if (parseInt(val) <= 0 || parseInt(val) >= 9) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'outcome_option':
      /**
       * 人工中絶 理由
       */
      break;

    case 'outcome_num1':
    case 'outcome_num2':
      if (state.outcome && state.outcome.indexOf("8") > -1) {
        if (!validator.isNumeric(value)) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'number_of_birth':
      if (isChildBirth(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('出産児数は必須入力です');
        }
        if (!validator.isNumeric(value)) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'delivery_date_year':
    case 'delivery_date_month':
    case 'delivery_date_day':
      if (isChildBirth(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('分娩日は必須入力です');
        }
        if (!validator.isNumeric(value)) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'delivery_date_year':
      if (isChildBirth(state.outcome)) {
        if (parseInt(value) > max_year || parseInt(value) < min_year ) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'delivery_date_month':
      if (isChildBirth(state.outcome)) {
        if (parseInt(value) > 12 || parseInt(value) < 0) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'delivery_date_day':
      if (isChildBirth(state.outcome)) {
        if (parseInt(value) > 30 || parseInt(value) < 1) {
          errs.push('入力内容が不正です');
        }
      }
      break;

    case 'delivery_style':
      if (isChildBirth(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('分娩様式は必須入力です');
        }
        if (!validator.isNumeric(value) || parseInt(value) > 4 || parseInt(value) <= 0) {
          errs.push('入力形式が不正です');
        }
      }
      break;

    case 'is_complications_before':
      if (isChildBirth(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('妊娠時の合併症の有無は必須入力です');
        }
      }

      if (isChildBirth(state.outcome)) {
        if (!validator.isNumeric(value) || parseInt(value) > 3 || parseInt(value) <= 0) {
          errs.push('入力形式が不正です');
        }
      }
      break;

    case 'is_complications_before_option':
      if (isChildBirth(state.outcome) && parseInt(state.is_complications_before) === 1) {
        if (value.length <= 0) {
          errs.push('妊娠時の合併症の内容を選択してください');
        }
      }
      break;

    case 'hospital_name':
      if (isChildBirth(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('出産病院名は必須入力です');
        }
      }
      break;

    case 'abortion_date_week':
    case 'abortion_date_day':
      /**
       * 流産時週数
       */
      if (isAbortion(state.outcome)) {
        if (validator.isEmpty(value)) {
          errs.push('流産時週数は必須入力です');
        }

        if (!validator.isNumeric(value)) {
          errs.push('入力形式が不正です');
        }
      }

    case 'abortion_date_week':
      /**
       * 流産時週数 週
       */
      if (isAbortion(state.outcome)) {
        // 入力が 100以上、もしくは 0未満
        if (parseInt(value) > 99 || parseInt(value) < 0) {
          errs.push('入力形式が不正です');
        }
      }
      break;

    case 'abortion_date_day':
      /**
       * 流産時週数 日
       */
      if (isAbortion(state.outcome)) {
        if (parseInt(value) > 6 || parseInt(value) < 0) {
          errs.push('入力形式が不正です');
        }
      }
      break;

    case 'abortion_surgical_year':
      if (isAbortion(state.outcome)) {
        if (!validator.isNumeric(value)) {
          errs.push('入力形式が不正です');
        }
      }
      if (isAbortion(state.outcome)) {
        if (parseInt(value) > max_year || parseInt(value) < min_year ) {
          errs.push('年の入力形式が正しくありません');
        }
      }
      break;

    case 'abortion_surgical_month':
      if (isAbortion(state.outcome)) {
        if (!validator.isNumeric(value)) {
          errs.push('入力形式が不正です');
        }
      }
      if (isAbortion(state.outcome)) {
        if (parseInt(value) <= 0 || parseInt(value) > 12) {
          errs.push('月の入力形式が正しくありません');
        }
      }
      break;

    case 'abortion_surgical_day':
      if (isAbortion(state.outcome)) {
        if (!validator.isNumeric(value)) {
          errs.push('入力形式が不正です');
        }
      }
      if (isAbortion(state.outcome)) {
        if (parseInt(value) <= 0 || parseInt(value) > 31) {
          errs.push('日の入力形式が正しくありません');
        }
      }
      break;

    case 'fetal_sac_size':
      if (isAbortion(state.outcome)) {
        if (!validator.isEmpty(value) && !validator.isNumeric(value)) {
          errs.push('入力形式が正しくありません');

          // 2桁から3桁まで
          if (parseInt(value) < 10 || parseInt(value) > 999) {
            errs.push('2桁から3桁までの数字で入力してください');
          }
        }
      }
      break;

    case 'chromosome_examination':
      if (isAbortion(state.outcome)) {
        //
      }
      break;

    case 'abortion_hospital_name':
      if (isAbortion(state.outcome)) {
        //
      }
      break;

    default:
      break;
  }

  if (isChildBirth(state.outcome) && parseInt(state.number_of_birth) > 0) {
    for (let i = 1; i <= parseInt(state.number_of_birth); i++) {
      errs = errs.concat(getChildBirthValidator(i, name, value));
    }
  }

  return errs;
};

/**
 * 妊娠の転帰が出産の場合 true それ以外は false
 *
 * @param outcome array outcomeの入力パラメータ
 * @return boolean 説明通り
 */
const isChildBirth = (outcome) => {
  return outcome.indexOf("1") > -1 || outcome.indexOf("2") > -1;
};

/**
 * 妊娠の転帰が流産の場合 true それ以外は false
 *
 * @param outcome array outcome の入力パラメータ
 * @return boolean 説明通り
 */
const isAbortion = (outcome) => {
  return outcome.indexOf("3") > -1;
};

/**
 * 出産数に応じたバリデーションの追加
 *
 * @param number Integer 児の数
 * @param name String フィールド名
 * @param value Mixin 値
 * @return errs エラーメッセージのオブジェクト
 */
const getChildBirthValidator = (number, name, value) => {
  let errs = [];
  let state = FormStore.getState();
  let i = number;

  if (name === `monozygotic_child_${i}`) {
    // 一卵性多胎
    if (validator.isEmpty(value)) {
      errs.push('一卵性多胎は必須入力です');
    }
    if (!validator.isNumeric(value)) {
      errs.push('入力が不正です');
    }
  } else if (name === `gender_${i}`) {
    // 性別
    if (validator.isEmpty(value)) {
      errs.push('性別は必須入力です');
    }
    if (value !== 'male' && value !== 'female') {
      errs.push('入力が不正です');
    }
  } else if (name === `weight_${i}`) {
    // 体重
    if (validator.isEmpty(value)) {
      errs.push('体重は必須入力です');
    }
    if (!validator.isNumeric(value)) {
      errs.push('体重は数字で入力してください');
    }
  } else if (name === `apgar_score1_${i}` || name === `apgar_score2_${i}`) {
    // アプガースコア
    if (value !== '' && !validator.isNumeric(value)) {
      errs.push('入力が不正です');
    }
    if (parseInt(value) < 0 || parseInt(value) > 10) {
      errs.push('アプガースコアは0〜10の数値で入力してください');
    }
  } else if (name === `birth_status_${i}`) {
    // 出産後の状態
    if (validator.isEmpty(value)) {
      errs.push('出産後の状態は必須入力です');
    }
    if (!validator.isNumeric(value)) {
      errs.push('入力が不正です');
    }
  }

  // 出産後の状態 追加項目
  if (parseInt(state.data[`birth_status_${i}`]) === 1 && name === `birth_status_option_${i}`) {
    if (value.length <= 0) {
      errs.push('出産後の状態は必須入力です');
    }
  }

  // 上記、「蘇生」「NICU入院」「奇形」「障害」「死産」を選択された場合の内容
  if (parseInt(state.data[`birth_status_${i}`]) === 2 || parseInt(state.data[`birth_status_option_${i}`]) > 1) {
    if (name === `birth_status_optional_${i}`) {
      if (value.length <= 0) {
        errs.push('以下の項目を選択してください');
      }
    }

    if (state.data[`birth_status_optional_${i}`].indexOf("7") > -1) {
      if (name === `birth_status_optional_content_${i}`) {
        if (value.length <= 0) {
          errs.push('以下の項目は必須入力です');
        }
      }
    }

    if (state.data[`birth_status_optional_${i}`].indexOf("8") > -1) {
      if (name === `birth_status_optional_text_${i}`) {
        if (validator.isEmpty(value)) {
          errs.push('以下の項目は必須入力です');
        }
      }
    }
  }

  // 出生後（1か月)
  if (name === `after_birth1_${i}` || name === `after_birth2_${i}`) {
    if (validator.isEmpty(value)) {
      errs.push('出生後（1か月)は必須入力です');
    }
    if (!validator.isNumeric(value)) {
      errs.push('入力が不正です');
    }
  }

  // 出生後（1か月) 死亡月日(西暦)
  if (parseInt(state.data[`after_birth1_${i}`]) === 2 || parseInt(state.data[`after_birth2_${i}`]) === 2) {
    if (name === `after_birth_option_year_${i}`) {
      if (validator.isEmpty(value)) {
        errs.push('死亡年は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('死亡年は数字で入力してください');
      }
      if (parseInt(value) > 2050 || parseInt(value) <= 1900) {
        errs.push('入力が不正です');
      }
    }
    if (name === `after_birth_option_month_${i}`) {
      if (validator.isEmpty(value)) {
        errs.push('死亡月は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('死亡月は数字で入力してください');
      }
      if (parseInt(value) > 12 || parseInt(value) <= 0) {
        errs.push('入力が不正です');
      }
    }
    if (name === `after_birth_option_day_${i}`) {
      if (validator.isEmpty(value)) {
        errs.push('死亡日は必須入力です');
      }
      if (!validator.isNumeric(value)) {
        errs.push('死亡日は数字で入力してください');
      }
      if (parseInt(value) > 31 || parseInt(value) <= 0) {
        errs.push('入力が不正です');
      }
    }
  }

  return errs;
};

export default Validator;
